import React, { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

const FullscreenToggle: React.FC = () => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);

  const toggleFullscreen = () => {
    const doc = document;
    const docEl = doc.documentElement;

    if (!isFullscreen) {
      if (docEl.requestFullscreen) docEl.requestFullscreen();
      else if ((docEl as any).webkitRequestFullscreen) (docEl as any).webkitRequestFullscreen();
      else if ((docEl as any).mozRequestFullScreen) (docEl as any).mozRequestFullScreen();
      else if ((docEl as any).msRequestFullscreen) (docEl as any).msRequestFullscreen();
    } else {
      if (doc.exitFullscreen) doc.exitFullscreen();
      else if ((doc as any).webkitExitFullscreen) (doc as any).webkitExitFullscreen();
      else if ((doc as any).mozCancelFullScreen) (doc as any).mozCancelFullScreen();
      else if ((doc as any).msExitFullscreen) (doc as any).msExitFullscreen();
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  return (
    <IconButton onClick={toggleFullscreen} color="inherit">
      {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
    </IconButton>
  );
};

export default FullscreenToggle;
